if (!customElements.get('cart-remove-button')) {
  customElements.define('cart-remove-button', class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault();
        this.cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
        this.mainProductId = this.closest('.cart-item').getAttribute('data-product-id');
        const isFreeSubscribed = this.closest('.cart-item').getAttribute('data-is-free-susbscribed');
        let freeSubscribedIndex = new Array();
        
        if(isFreeSubscribed == 'false') {
          const freeSubscribedProduct = document.querySelectorAll('.cart-item[data-parent-product-id="'+this.mainProductId+'"]');
          if(freeSubscribedProduct.length > 0) {            
            freeSubscribedProduct.forEach((product) => {
              var variantId = product.getAttribute('data-variant-id');
              var obj = {variantId : variantId, qty: 0};
              freeSubscribedIndex.push(obj);
            });
            this.cartItems.updateCartItems(freeSubscribedIndex, this.mainProductId, 0, '');
          }
        }
        if(freeSubscribedIndex.length == 0) {
          this.cartItems.updateQuantity(this.dataset.index, 0);
        }
      });
    }
  });
}

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  async getCartItems() {
    const response = await fetch('/cart.js', { ...getConfig() });
    if(response.ok) {
      const returnRes = await response.json();
      return returnRes.items;
    } else {
      return null;
    }
  }

  async updateCartItems(productIDS, productId, updateQty, attName) {    
    if(productIDS.length > 0) {
      let formData = {
        'updates': {}
      };
      for (var i=0; i<productIDS.length;i++) {
        formData['updates'][parseInt(productIDS[i].variantId)] = productIDS[i].qty;
      }
      let info = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      
      if (info.ok) {
        const newCartItems = await this.getCartItems();
        if(newCartItems != null && newCartItems.length > 0) {
          newCartItems.forEach((item, index) => {
            if(item.product_id == productId) {
              this.updateQuantity(index+1, updateQty, attName);
            }
          });
        }
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  async onChange(event) {
    const isFreeSubscribed = event.target.closest('.cart-item[data-index="'+event.target.dataset.index+'"]').getAttribute('data-is-free-susbscribed');
    if(isFreeSubscribed == 'true') {
      //free subscribed product cant be updated
      return false;
    }
    let attName = document.activeElement.getAttribute('name');
    if(attName == "product-frequency") {
      attName = attName+'::'+document.activeElement.getAttribute('product-quantity')+'::'+document.activeElement.getAttribute('unit-type');
    }
    const res = await this.updateSubscPrducts(event, attName);
    if(!res) {
      this.updateQuantity(event.target.dataset.index, event.target.value, attName);
    }    
  }

  async updateSubscPrducts(event, attName) {
    
    let getAssociatedProducts = [];
    //if product quantity is decreased then its associated free subscribed product should also be decreased
    const activeElProductId = event.target.closest('.cart-item').getAttribute('data-product-id');
    const activeElProductFreeSubs = event.target.closest('.cart-item').getAttribute('data-is-free-susbscribed');
    const activeProductQty = event.target.value;
    if(activeElProductFreeSubs == 'false') {
      var totalFreeSubsPrQty = 0;
      const freeSubsProducts = document.querySelectorAll('.cart-item[data-parent-product-id="'+activeElProductId+'"][data-is-free-susbscribed="true"]');
      if(freeSubsProducts.length > 0) {          
        freeSubsProducts.forEach((product) => {
          const productMaxQty = product.querySelector('input').value;
          const selectedIndex = product.dataset.index;
          totalFreeSubsPrQty += parseInt(productMaxQty);   
          const associatedProduct = {'qty':parseInt(productMaxQty),'parent_product_id':activeElProductId,'item_index':selectedIndex, 'variant_id': product.getAttribute('data-variant-id'),'oldqty':parseInt(productMaxQty)};
          getAssociatedProducts.push(associatedProduct);
        });  
        if(activeProductQty < totalFreeSubsPrQty) {
          let extraFreeSubsPrQty = totalFreeSubsPrQty - activeProductQty;
          // Logic will go here; If it extrafree is larger then product quantity then we have to remove extra free associated products
          let abc = 0;
          while(extraFreeSubsPrQty > 0 && abc <20) {
            if(getAssociatedProducts.length>0) {
              for(var i=0; i< getAssociatedProducts.length; i++ ){
                var currentObj = getAssociatedProducts[i];
                if(currentObj.qty > 0 && extraFreeSubsPrQty > 0){
                  getAssociatedProducts[i].qty = parseInt(currentObj.qty)-parseInt(1);
                  extraFreeSubsPrQty--;
                } 
              }
            }
            abc++;
          }
          let productIDS = new Array();
          for(var i=0; i< getAssociatedProducts.length; i++ ){              
            var currentObj = getAssociatedProducts[i];
            if(currentObj.oldqty != currentObj.qty) {
              getAssociatedProducts[i].oldqty = currentObj.qty;
              var obj = {variantId : getAssociatedProducts[i].variant_id, qty: currentObj.qty};
              productIDS.push(obj);
            }
          }
          return this.updateCartItems(productIDS, activeElProductId, activeProductQty, attName);            
        } else {
          return false;
        }       
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {    
    this.enableLoading(line); 
    var checkUpdateLiveRegionsFun = true;   
    var body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    if(name && name.startsWith("product-frequency")) {
      checkUpdateLiveRegionsFun = false;
      const nameWithQuantityBreak = name.split("::");
      const shipping_frequency = quantity;
      const productQuantity = nameWithQuantityBreak[1];
      const shippingUnitType = nameWithQuantityBreak[2];
      quantity = productQuantity;    
      var body = JSON.stringify({
        line,
        quantity,
        properties: { shipping_interval_unit_type: shippingUnitType , shipping_interval_frequency: shipping_frequency },
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
    }  
    
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        if(checkUpdateLiveRegionsFun) {
          this.updateLiveRegions(line, parsedState.item_count);
        }
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};
